import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { interval } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
// import { CrashService } from './crash.service';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  currentLoading = null;
  showing = false;

  constructor(
    public loadingController: LoadingController, // private crash: CrashService,
  ) {}

  async showLoader(source) {
    // console.log(`${source} called show spinner`);
    this.showing = true;

    // Dismiss previously created loader
    if (this.currentLoading != null) {
      // console.log('spinner instance already exists, clear it');
      this.currentLoading.dismiss();
    }

    // console.log('create a spinner instance');
    // Show the loader for infinite time
    this.currentLoading = await this.loadingController.create();

    // console.log('show the spinner instance');
    if (this.currentLoading) {
      await this.currentLoading.present();
    }
    this.showing = false;
    return;
  }

  // Hide the loader if already created otherwise return error
  hideLoader(source) {
    let hidden = false;
    // console.log(`${source} called hide spinner`);
    interval(300)
      .pipe(takeWhile(() => !hidden))
      .subscribe(
        async () => {
          // console.log('spinner hide triggered');
          if (this.currentLoading != null) {
            // console.log('spinner instance exists, dismiss it');
            try {
              await this.loadingController.dismiss();
            } catch (error) {
              console.log('failed to hide spinner', error);
            }
            // console.log('reset spinner instance to null');
            this.currentLoading = null;
            hidden = true;
          } else {
            // console.log('no spinner instance exists');
            if (this.showing) {
              // console.log(
              //   'But spinner is in the process of showing, so hide it anyway',
              // );
              try {
                await this.loadingController.dismiss();
              } catch (error) {
                console.log('failed to hide spinner', error);
              }
            }
          }
        },
        (e) => {
          // JL_TODO: resolve this - cannot report without circular reference to CrashService
          console.log('failed to hide spinner');
          // this.crash.process(
          //   'loader-service',
          //   'hideLoader',
          //   `Error hiding spinner`,
          //   { source, e },
          // );
        },
        () => {
          console.log('spinner hidden');
        },
      );
  }
}
